import { MENU_KEY_ROUTES } from "src/constants";
import { GiftcardsListing, GiftcardsDetails } from "src/Modules/GiftCards/pages";
export const giftcardRoutes = {
  path: MENU_KEY_ROUTES["GiftCards"],
  children: [
    {
      index:true,
      element: <GiftcardsListing/>
    },
    {
      path:":code",
      element:<GiftcardsDetails/>
    }
  ],
};